<template>
    <div class="c-right">
        <div class="chart-content" ref="chartContent">
            <template v-if="chatList.length">
                <div class="chart-item" :class="{ 'is-they': item.assistantType == 2 }" v-for="(item, index) in chatList"
                    :key="index">
                    <div class="icon" v-if="item.assistantType == 1">{{ userInfo.employeeName }}</div>
                    <div class="icon icon-pic" v-else></div>
                    <div v-if="item.urls" :ref="'image_' + index">
                        <div class="pic-item" v-for="(path, p_index) in item.urls" :key="p_index"
                            @click="clickPic('image_' + index)">
                            <img :src="path">
                        </div>
                    </div>
                    <div v-else class="text">
                        <span v-html="format(item.content, index)"></span>
                        <span class="ailoading" v-if=" index == chatList.length - 1 && aiLoading">AI思考中。。。</span>
                        <el-button type="text" size="mini" @click="remove(index)">删除</el-button>
                    </div>
                </div>
            </template>
            <div class="tip" v-else>
                <div class="title">AI对话</div>
                <div class="label">发消息给AI,开始对话</div>
            </div>
        </div>
        <div class="footer">
            <div class="tool">
                <el-button type="text" size="mini" @click="edit" v-if="chatList.length && this.tabValue != 3">
                    <span v-if="isDisagled && this.tabValue == 1">停止回复</span>
                    <span v-else>重新生成</span>
                </el-button>
            </div>
            <div class="tab">
                <span v-buttonAuth="'bookAndDrug:aichat'" class="tab-item" :class="{ active: 1 == tabValue }"
                    @click="clickTab(1)">文字对话</span>
                <span v-buttonAuth="'bookAndDrug:aiimage'" class="tab-item" :class="{ active: 2 == tabValue }"
                    @click="clickTab(2)">AI创图</span>
                <!-- <span v-buttonAuth="'bookAndDrug:voicetotext'" class="tab-item" :class="{ active: 3 == tabValue }" @click="clickTab(3)">录音转文字</span> -->
                <!-- <div class="right">
                    <span class="size">{{ size }}/{{ maxSize }}</span>
                    <el-progress :show-text="false" :percentage="percentage"></el-progress>
                </div> -->
            </div>
            <div>
                <uploadpic v-if="tabValue == 3" @success="chatVoiceToText" />
                <el-input v-else :disabled="isDisagled" v-model="keyword" placeholder="发送消息。。。"
                    @keyup.enter.native="postData">
                    <i class="el-icon-position el-input__icon" slot="suffix" @click="postData" v-if="!isDisagled"></i>
                    <span v-else class="icon-more" slot="suffix">
                        <i class="el-icon-more el-input__icon"></i>
                    </span>
                </el-input>
            </div>
        </div>
    </div>
</template>

<script>
import viewer from "viewerjs";
import uploadpic from "./uploadpic.vue"
import { mapGetters } from 'vuex';
export default {
    name: "chatGpt",
    components: {
        uploadpic,
    },
    props: {
        info: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    computed: {
        ...mapGetters(["userInfo", "chatGptMsg", "aiLoading", "completeTokens"]),
        percentage() {
            return this.size / this.maxSize * 100;
        },
        size() {
            return this.chatList.reduce((num, i) => {
                return num += i.size || 0;
            }, 0)
        }
    },
    watch: {
        completeTokens(val) {
            this.setSize(val.size);
        },
        chatGptMsg(val) {
            this.setMsg(val);
        },
        info() {
            localStorage.removeItem("menuInfo")
            this.init();
        }
    },
    data() {
        return {
            maxSize: 4097,
            menuInfo: {},
            keyword: "",
            saveKeyword: "",
            loading2: false,
            isDisagled: false,
            jsq: null,
            nowMsg: {},
            tabValue: 1,
            chatList: [],
            tabList: [
                {
                    label: "文字对话",
                    value: 1,
                },
                {
                    label: "AI创图",
                    value: 2,
                },
                {
                    label: "录音转文字",
                    value: 3,
                },
            ],
        };
    },
    methods: {
        setSize(val) {
            let item = this.chatList[this.chatList.length - 1];
            if (item.assistantType == 1) item.size = val - this.size;
        },
        remove(index) {
            this.$confirm("确定要删除吗", "提示").then(() => {
                this.chatList.splice(index, 1);
                this.localSave();
                this.saveMenu();
            })
        },
        localSave() {
            localStorage.setItem("menuInfo", JSON.stringify(
                {
                    chatList: this.chatList,
                    menuInfo: this.menuInfo
                }
            ));
        },
        sendMsg() {
            this.$store.commit("setAiLoading", false)
            let obj = {
                "clientId": this.userInfo.socketClientId,
                "key": "disconnectChatGpt"
            };
            this.$store.commit("sendMessage", obj);
            this.isDisagled = false;
            this.loading2 = false;
            this.saveMenu();
        },
        edit() {
            switch (this.tabValue) {
                case 1: {
                    if (this.isDisagled) {
                        this.sendMsg();
                    } else {
                        this.chatAnswers(true);
                    }
                } break;
                case 2: {
                    this.chatGenImages(this.saveKeyword);
                } break;
            }
        },
        clickPic(ref) {
            if (this.picView) this.picView.destroy();
            this.picView = new viewer(this.$refs[ref][0]);
        },
        format(str, index) {
            if (index == this.chatList.length - 1 && this.loading2) {
                str += '<i class="ailoading black"></i>';
            }
            // eslint-disable-next-line no-undef
            return str ? marked.parse(str) : "";
        },
        chatVoiceToText(res) {
            this.chatList.push(...res);
            setTimeout(() => {
                this.$refs.chartContent.scrollTop = 1000000;
            }, 300);
        },
        setMsg() {
            if (!this.loading2) {
                this.nowMsg = {
                    "assistantType": 2,
                    "content": "",
                    "role": "user",
                };
                this.chatList.push(this.nowMsg);
                this.loading2 = true;
                this.keyword = "";
            }
            clearTimeout(this.jsq);
            this.nowMsg.content += this.chatGptMsg.content || "";
            this.$refs.chartContent.scrollTop = 1000000;
            if (this.chatGptMsg.end) {
                this.nowMsg.size = this.chatGptMsg.size || 0;
                this.loading2 = false;
                this.isDisagled = false;
                // 保存数据
                this.saveMenu();
            }
            this.localSave();
        },
        clickTab(value) {
            this.tabValue = value;
        },
        saveMenu() {
            let obj = {
                sessionId: this.menuInfo.sessionId || null, // 会话Id 
                sessionTitle: this.menuInfo.sessionTitle || this.chatList[0].content, // 会话标题 
                sessionJson: JSON.stringify({
                    chatList: this.chatList,
                    tokensSize: this.tokensSize
                }), // 会话JSON  
            }
            this.$store.commit("showLoading")
            this.api("saveChatGptSessionHistory", obj).then(res => {
                this.$store.commit("hideLoading")
                this.menuInfo.sessionId = res.result.sessionId;
                this.$emit("renovateMenu");
            })
        },
        postData() {
            if (!this.keyword) {
                this.$message.warning("请输入内容后提交");
                return;
            }
            switch (this.tabValue) {
                case 1:
                    this.chatAnswers();
                    break;
                case 2:
                    this.chatGenImages(this.keyword);
                    break;
            }
        },
        chatGenImages(keyword) {
            if (!keyword) {
                this.$message.warning("请输入内容后提交");
                return;
            }
            this.saveKeyword = keyword;
            let obj = {
                imageMode: "dall-e-2", 
                text: keyword,
                size: "1024x1024"
            }
            this.$store.commit("showLoading", "AI思考中。。。")
            this.api("chatGenImages", obj).then(res => {
                let result = JSON.parse(res.result);
                this.$store.commit("hideLoading")
                this.chatList.push(
                    {
                        "assistantType": 1,
                        "content": keyword
                    },
                    {
                        "assistantType": 2,
                        "urls": result.data.map(i => i.url)
                    },
                )
                this.keyword = "";
                setTimeout(() => {
                    this.$refs.chartContent.scrollTop = 1000000;
                }, 300);
            })
        },
        chatAnswers(isAgain) {
            if (!isAgain) {
                this.chatList.push({
                    "assistantType": 1,
                    "content": this.keyword,
                    "size": 0,
                });
                this.saveKeyword = this.keyword;
            }

            let obj = {
                "clientId": this.userInfo.socketClientId,
                "contentDTOList": this.chatList.filter(i=>i.content).map(i => {
                        i.role = i.assistantType == 1 ? "user" : "assistant";
                    return i;
                }),
                "gptMode": "gpt-3.5-turbo"
            };

            this.$store.commit("setAiLoading", true)
            this.loading2 = false;
            this.isDisagled = true;
            clearTimeout(this.jsq);
            // 超时取消输入禁用功能
            this.jsq = setTimeout(() => {
                this.$store.commit("setAiLoading", false)
                this.isDisagled = false;
            }, 90000);

            this.api("completions", obj).then(res => {
                this.keyword = "";
                let s = this.toStr(res);
                if (s) {
                    this.chatList.push({
                        "assistantType": 2,
                        "content": s,
                        "size": 0,
                    });
                }
                this.$store.commit("setAiLoading", false)
                this.isDisagled = false;
                this.saveMenu();
            })

        },
        toStr(obj) {
            let list = obj.result.split("data: ").filter(i => i)
            list.pop();
            list = list.map(i => JSON.parse(i))
            let str = list.map(j => {
                return j.choices.reduce((str, i) => {
                    return str + (i.delta.content || "");
                }, "")
            }).join("")
            return str;
        },
        init() {
            this.menuInfo = this.info;
            if (this.info.sessionJson) {
                let s = JSON.parse(this.info.sessionJson)
                if (s instanceof Array) {
                    this.chatList = s;
                } else {
                    this.chatList = s.chatList || [];
                }
            } else {
                this.chatList = [];
            }
        }
    },
    created() {
        this.init();
        let getSave = localStorage.getItem("menuInfo")
        if (getSave) {
            getSave = JSON.parse(getSave);
            this.chatList = getSave.chatList;
            this.menuInfo = getSave.menuInfo
        }
    },
    destroyed() {
        this.sendMsg();
    },
}
</script>
